import React  from 'react'
import HeadersContainer from "./information/headers/HeadersContainer";
import IngredientsContainer from "./information/ingredients/IngredientsContainer";
import IngredientsMidValue from "./information/ingredients/IngredientsMidValue";
import RecipeUpdateProductionCosts from "./information/productioncost/RecipeUpdateProductionCosts";
import UpdateProductionCostSubTotal from "./information/productioncost/UpdateProductionCostSubTotal";
import {Col, Row} from "antd";

const RecipeUpdateList = ({recipe}) => {

    return (
        <React.Fragment>
            <Row>
                <Col span={24}>
                    <HeadersContainer/>
                </Col>
                <Col span={24}>
                    <IngredientsContainer/>
                </Col>
            </Row>
            <Row justify={"end"}>
                <Col span={10}>
                    <IngredientsMidValue />
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <RecipeUpdateProductionCosts />
                </Col>
            </Row>
            <Row justify={'end'}>
                <Col span={5}>
                    <UpdateProductionCostSubTotal />
                </Col>
            </Row>
        </React.Fragment>
    )
}
export default RecipeUpdateList